import React, { Dispatch, SetStateAction } from "react";
import "./FormSectionAceleradora.scss";

import FormInputAceleradora from "../../atoms/form-input-aceleradora/FormInputAceleradora";
import { IInputDataReference } from "../../../interfaces/ReferenciaEmpleoDigital";
import { BLOCKS, INLINES } from "@contentful/rich-text-types";
import rawToReact from "../../../utils/rawToReact";

interface ISectionFormAceleradoraTwo {
    setActiveIndex: Dispatch<SetStateAction<number>> | ((step: number) => void);
    activeIndex: number;
    titleSection: any;
    inputsSection: any;
    formValues: any;
    setInputValue: any;
    inputsErrorList: string[];
    customErrorMessageList: any;
    inputDisabled: string[];
    validBirthDate?: boolean;
    dateState?: any;
    talleresData?: any;
    dateStateHelper?: boolean;
    setDateStateHelper?: any;
}

const dataProcessingAuthorizationFieldName = "dataProcessingAuthorization";

const renderDataProcessingAuthorizationLabel = (rawText: string) => {
    const contentFullRenderLabel = {
        renderNode: {
            [INLINES.HYPERLINK]: ({ data }: any, children) => (
                <a
                    style={{ color: "var(--color-magenta-white)" }}
                    href={data.uri}
                    target={"_blank"}
                    className="link-authorize-data"
                    rel={"noopener noreferrer"}
                >
                    {children}
                </a>
            ),
            [BLOCKS.PARAGRAPH]: (node: any, children: any) => (
               children
            ),
        },
    };

    return rawToReact(rawText, contentFullRenderLabel) as string;
};

const FormSectionAceleradoraTwo = (props: ISectionFormAceleradoraTwo) => {

    return (
        <div
            className={`m-section-form-aceleradora m-form-aceleradora-inputs-group  m-section-form-${props.inputsSection[0]?.seccion}`}
        >
            {props.inputsSection?.map((input, index) => {
                const isDataProcesingField =
                    input.nombreId === dataProcessingAuthorizationFieldName;

                const a = props.customErrorMessageList.filter(
                    (e) => e.nombreId === input.nombreId
                );

                return (
                    <FormInputAceleradora
                        key={`input-${input.nombreId}`}
                        title={
                            isDataProcesingField
                                ? undefined
                                : input.inputPrincipal
                        }
                        labelContent={
                            isDataProcesingField
                                ? renderDataProcessingAuthorizationLabel(
                                      input.textoTerminos.raw
                                  )
                                : undefined
                        }
                        value={props.formValues[input.nombreId]}
                        nombreId={input.nombreId}
                        type={input.tipoCampo}
                        setInputValue={props.setInputValue}
                        isError={
                            props.inputsErrorList.indexOf(input.nombreId) !== -1
                        }
                        errorMessage={
                            a.length > 0
                                ? a[0].errorMessage
                                : input.mensajeError
                        }
                        textoTerminos={input.textoTerminos}
                        tituloBotonTerminos={input.tituloBotonTerminos}
                        checked={
                            props.formValues[input.nombreId] ? true : false
                        }
                        isRequired={input.obligatorio}
                        disabled={props.inputDisabled?.includes(input.nombreId)}
                        options={input.listaSelect}
                        validBirthDate={props.validBirthDate}
                        tabOrder={"0"}
                        dateState={props.dateState}
                        ayuda={
                            input.nombreId == "disability"
                                ? props.inputsSection[index]?.ayuda
                                : ""
                        }
                        talleresData={props.talleresData}
                        placeholder={input.placeholder}
                        dateStateHelper={props.dateStateHelper}
                        setDateStateHelper={props.setDateStateHelper}
                    ></FormInputAceleradora>
                );
            })}
        </div>
    );
};

export default FormSectionAceleradoraTwo;
